import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface Circuit {
  id: string
  name: string
  period: 'AM' | 'PM'
  transporterName: string
  schoolName: string
  isActive: boolean
}

interface CircuitsState {
  items: Circuit[]
  loading: boolean
}

const initialState: CircuitsState = { items: [], loading: false }

const circuitsSlice = createSlice({
  name: 'circuits',
  initialState,
  reducers: {
    setCircuits: (state, action: PayloadAction<Circuit[]>) => { state.items = action.payload },
    setLoading: (state, action: PayloadAction<boolean>) => { state.loading = action.payload },
  },
})

export const { setCircuits, setLoading } = circuitsSlice.actions
export default circuitsSlice.reducer
